// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3InDd","content":"styles_content__HhktJ","row":"styles_row__xrcf3","footer":"styles_footer__2SY8H","phraseLength":"styles_phraseLength__3ToSM"};